export default __webpack_public_path__ + "static/media/token_tracker.0b4ab208.png";